/* 
Common code for each of the views making up the user page.
*/
import * as action from "@/store/prisms-users/action-types";

export default {
  computed: {
    userId() {
      return parseInt(this.$route.params.id);
    },
    nextPageAction() {
      return action.LIST_NEXT_PAGE;
    },
    previousPageAction() {
      return action.LIST_PREVIOUS_PAGE;
    },
    state() {
      return this.$store.state.prismsUsers.view;
    },
    loaded() {
      return this.state.loaded;
    },
    user() {
      return this.state.data;
    },
    breadcrumbs() {
      return this.state.breadcrumbs;
    },
    title() {
      return this.user.familyName ? `${this.user.firstName} ${this.user.familyName}` : "...";
    },
    subtitle() {
      return this.user.emailAddress ? this.user.emailAddress : "";
    }
  },
  watch: {
    userId() {
      this.reload();
    },
    loaded() {
      this.reload();
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      this.$store.dispatch(action.VIEW_REFRESH, this.userId);
    }
  }
};
